export default "__VITE_ASSET__DKtInted__"